/** Salon-level privileged roles (full authority within their tenant). */
export const SALON_ADMIN_ROLES = new Set(["admin", "tenant_owner"]);

/** Roles that can confirm staff payouts and manage rota schedules. */
export const SALON_PAY_MANAGER_ROLES = new Set(["admin", "tenant_owner", "manager"]);

export function isSalonAdmin(role) {
  return SALON_ADMIN_ROLES.has(role);
}

export function canManageStaffPay(role) {
  return SALON_PAY_MANAGER_ROLES.has(role);
}

/** Salary, identity, and full employee HR card — manager / owner roles only. */
export function canViewEmployeeHr(role) {
  return canManageStaffPay(role);
}

/** Owner board on Bookings: calendar/list + branch filter (admin + tenant_owner). */
export function canViewBookingsOwnerBoard(role) {
  return isSalonAdmin(role);
}

export function canVoidInvoice(role) {
  return isSalonAdmin(role);
}
